import type { FC } from 'react'

export type TRoutePageType = {
  element: FC
  path: string
  title: string
  isPrivate?: boolean
}

export enum ERoutePaths {
  Home = '/',
  Category = '/category',
  Information = '/information/:id',
  Wishlist = '/wishlist',
  Basket = '/basket',
  Product = '/product/:id',
  Error = '*',
}
